// extracted by mini-css-extract-plugin
export default {"delete":"Delete_delete__QSG9X"};